<template lang="pug">
.menu-trigger(:class="activeClass")
  span(:style="colorStyle")
  span(:style="colorStyle")
  span(:style="colorStyle")
</template>

<script>
import {mapState} from 'Vuex'
export default {
  props:{
    propColor:{
      type: String,
      default: "#fff"
    }
  },
  components: {},
  data () {
    return {}
  },
  computed: {
    ...mapState('menu', {isShowMenu: 'isShow'}),
    activeClass(){
      return this.isShowMenu ? 'active' : ''
    },
    color(){
      if(this.isShowMenu){
        return "#fff"
      }
      return this.propColor
    },
    colorStyle(){
      return {backgroundColor: this.color}
    }
  },
  methods: {},
  created () {},
  mounted () {},
}
</script>


<style lang="stylus" scoped>
.menu-trigger
  cursor pointer
.menu-trigger,
.menu-trigger span
  display inline-block
  transition all .4s
  box-sizing border-box
.menu-trigger
  position relative
  width 25px
  height 14px
.menu-trigger span
  position: absolute
  left 0
  width 100%
  height 2px
.menu-trigger span:nth-of-type(1)
  top 0
.menu-trigger span:nth-of-type(2)
  top 6px
.menu-trigger span:nth-of-type(3)
  bottom 0
.menu-trigger.active span:nth-of-type(1)
  transform translateY(7px) rotate(-45deg) scaleX(1.4)
.menu-trigger.active span:nth-of-type(2)
  left 50%
  opacity 0
  animation active-menu-bar02 .8s forwards
@-webkit-keyframes active-menu-bar02
  100%
    height 0
@keyframes active-menu-bar02
  100%
    height 0
.menu-trigger.active span:nth-of-type(3)
  transform translateY(-6px) rotate(45deg) scaleX(1.4)
</style>
